<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer class="sidenav custom-scroll-bar" fixedInViewport
        [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
        [mode]="(isHandset$ | async) ? 'over' : 'side'"
        [opened]="(isHandset$ | async) === false">

        <div>
            <mat-toolbar
            style="text-align: center; background-color: white;
            box-shadow: 0 0 2px 3px #eee; justify-content: center;">
                <img src="assets/images/icpc-logo.png" alt="logo" width="60px">
            </mat-toolbar>


            <!-- <mat-toolbar [style.padding-left]="drawerOpen ? '5px' : '5px' ">
             <div *ngIf="(isHandset$ | async) ? true : drawerOpen">
                <button
                class="fab_alt"
                [style.left]="!drawerOpen ? '38px' : '205px'"
                 mat-fab color='primary'
                (click)="drawerOpen = !drawerOpen"
                >
                <mat-icon *ngIf='drawerOpen' style="color: #fff;">menu_open</mat-icon>
                <mat-icon *ngIf='!drawerOpen' style="color: #fff;">keyboard_arrow_right</mat-icon>

              </button>
              </div>
            </mat-toolbar> -->



            <div class="side-wrapper">
              <mat-nav-list class="menu-container">
                <div *ngFor="let item of authorizedMenu">
                  <a mat-list-item [routerLink]="item.route" *ngIf="allowAccess(item.roles)"
                    style="display: flex; justify-content:space-between; height: 55px;"
                    routerLinkActive="active-link">
                          <div class="menu-list-text">
                      <div class="side-icon"><mat-icon fontSet="material-icons-outlined">{{item.icon}}</mat-icon></div>
                      <div class="sidebar-name"> {{item.name}} </div>
                    </div>
                    <mat-divider class="menu-divider"></mat-divider>

                  </a>

                </div>
              </mat-nav-list>

              <div class="flex-center mb-3">
                <div style="text-align: center;">
                  <div class="login-hover" style="cursor: pointer;" (click)="logout()" routerLink="/">
                    <div class="side-icon"><mat-icon fontSet="material-icons-outlined">logout</mat-icon></div>
                    <div class="sidebar-name"> Logout </div>
                  </div>

                  <!-- <button mat-icon-button >
                    <mat-icon>logout</mat-icon>
                  </button> -->

                  <div  [matMenuTriggerFor]="menu">
                    <div style="cursor: pointer" class="avatar2 mt-1" >
                      {{getInitials(userDetails?.fullname)}}
                    </div>
                      <!-- <div #image style="width: 100%; height: 100%;"></div> -->
                  </div>

                  <mat-menu #menu="matMenu" class="menu-dropdown" yPosition="above" [hasBackdrop]="true">
                    <div class="flex-el start" style="padding:10px 12px; color: black;">
                      <div class="avatar2" >
                        {{getInitials(userDetails?.fullname)}}
                      </div>

                      &nbsp;
                      &nbsp;
                      &nbsp;

                      <div>
                        <div class="bold-500">{{userDetails?.fullname}}</div>
                        <div style="font-size: smaller;">
                          {{userDetails?.contactEmail}}
                        </div>
                        <div class="bold-300" style="color: #ce0101;">{{userDetails?.roletype}}</div>

                      </div>
                    </div>
                  </mat-menu>
                </div>

              </div>



            </div>
        </div>

    </mat-sidenav>

    <mat-sidenav-content>
      <mat-toolbar *ngIf="isHandset$ | async">
        <div class="flex-btw full-width">
          <img src="assets/images/EFCC-logo-dark.png" alt="logo" width="60px">

          <button
            type="button"
            aria-label="Toggle sidenav"
            mat-icon-button
            (click)="drawer.toggle()"
            *ngIf="isHandset$ | async">
            <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
          </button>
        </div>
      </mat-toolbar>
      <router-outlet></router-outlet>
      <!-- Add Content Here -->
    </mat-sidenav-content>

  </mat-sidenav-container>
